module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-68db6f84.png";